import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ContactTypes} from "../contact-dropdown-button/contact-dropdown-button.component";
import {FormArray, FormControl, FormGroup} from "@angular/forms";

export interface DeleteContact {
    index: number,
    contactType: ContactTypes
}

@Component({
    selector: 'contacts-template',
    templateUrl: './contacts-template.component.html',
    styleUrls: ['./contacts-template.component.scss']
})
export class ContactsTemplateComponent implements OnInit {

    @Input() contactInfo: FormGroup;
    @Output() delete: EventEmitter<DeleteContact> = new EventEmitter();

    readonly ContactTypes = ContactTypes;
    readonly emailTypes = ['Home', 'Work'];
    readonly phoneTypes = ['Mobile', 'Home', 'Work', 'Main'];
    readonly urlTypes = ['Home Page', 'Home', 'Work'];
    readonly addressFilteredOptions = ['Home', 'Work'];

    get addresses() {
        return (this.contactInfo.get('addresses') as FormArray).controls as FormControl[];
    }

    get emails() {
        return (this.contactInfo.get('emails') as FormArray).controls as FormControl[];
    }

    get organisations() {
        return (this.contactInfo.get('org') as FormArray).controls as FormControl[];
    }

    get phones() {
        return (this.contactInfo.get('phones') as FormArray).controls as FormControl[];
    }

    get urls() {
        return (this.contactInfo.get('urls') as FormArray).controls as FormControl[];
    }

    get birthdays() {
        return (this.contactInfo.get('birthdays') as FormArray).controls as FormControl[];
    }

    constructor() {
    }

    ngOnInit(): void {
    }

    deleteTemplate(index: number, contactType: ContactTypes) {
        const cont = this.contactInfo.get(contactType) as FormArray;
        cont.removeAt(index);
        this.delete.emit({
            index,
            contactType
        })
    }

}
